import { PHASE } from "./constants.ts";

export type DashboardContractStatus =
	| { count: 0; kind: "clear" }
	| { count: number; kind: "planning" }
	| { count: number; kind: "actionable" };

// A contract ending this season is planning information until the league
// actually creates a re-signing negotiation. Only the negotiation queue is an
// actionable decision, because that is the queue the destination screen reads.
export const getDashboardContractStatus = ({
	contractExpiringCount = 0,
	pendingNegotiationCount = 0,
	phase,
}: {
	contractExpiringCount?: number;
	pendingNegotiationCount?: number;
	phase?: number;
}): DashboardContractStatus => {
	if (phase === PHASE.RESIGN_PLAYERS) {
		return pendingNegotiationCount > 0
			? { count: pendingNegotiationCount, kind: "actionable" }
			: { count: 0, kind: "clear" };
	}

	if (
		(phase === undefined || phase < PHASE.RESIGN_PLAYERS) &&
		contractExpiringCount > 0
	) {
		return { count: contractExpiringCount, kind: "planning" };
	}

	return { count: 0, kind: "clear" };
};
